import { render, staticRenderFns } from "./webNew.vue?vue&type=template&id=488894e6&scoped=true&"
import script from "./webNew.vue?vue&type=script&lang=js&"
export * from "./webNew.vue?vue&type=script&lang=js&"
import style0 from "./webNew.vue?vue&type=style&index=0&id=488894e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488894e6",
  null
  
)

export default component.exports